export default __webpack_public_path__ + "static/prize-a6b437560b0be85f1a913f1e68db7fb5.png";